module.exports = __webpack_public_path__ + "static/media/removeIcon.efef6f4b.png";